import React from "react";
import Text from "../Text";

export default function RequireIndicator() {
  return <Text type="H3" center={true} color={"gray"} semibold>*</Text>;
}
